/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnshadowbanUserResponse } from '../../models/unshadowban-user-response';

export interface AbuseServiceUnshadowbanUser$Params {
  userId: string;
}

export function abuseServiceUnshadowbanUser(http: HttpClient, rootUrl: string, params: AbuseServiceUnshadowbanUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UnshadowbanUserResponse>> {
  const rb = new RequestBuilder(rootUrl, abuseServiceUnshadowbanUser.PATH, 'delete');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnshadowbanUserResponse>;
    })
  );
}

abuseServiceUnshadowbanUser.PATH = '/api/v3/gateway/admin/shadowban/{userId}';
